import React, { useState, useEffect } from "react";
import Col from "react-bootstrap/esm/Col";
import { useDrop } from "react-dnd";

export default function Goal(props) {
  const [{ isOver }, goal] = useDrop(() => ({
    accept: "word",
    drop: (item) => addWord(item.name),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const [draggedWord, setDraggedWord] = useState();
  const [incorrectValue, setIncorrectValue] = useState(false);
  const answer = props.answer.replaceAll(" ", ",").split(",");

  const addWord = (name) => {
    setDraggedWord(name);
    const newGuess = props.guess;
    newGuess[props.x] = name;
    const newAnsweredGuess = props.guess.toString();
    props.setGuessedAnswer(newAnsweredGuess.replaceAll(",", " "));
    props.setAttempts((a) => a + 1);
    props.setGuess(newGuess);
    if (answer[props.x] === name) {
      setIncorrectValue(false);
    } else {
      setIncorrectValue(true);
    }
  };

  useEffect(() => {
    if (props.hint === true) {
      if (incorrectValue === true || draggedWord === undefined) {
        if (answer[props.x] === props.passHint) {
          setDraggedWord(props.passHint);
          const newGuess = props.guess;
          newGuess[props.x] = props.passHint;
          const newAnsweredGuess = props.guess.toString();
          props.setGuessedAnswer(newAnsweredGuess.replaceAll(",", " "));
          props.setAttempts((a) => a + 1);
          props.setGuess(newGuess);
          if (answer[props.x] === props.passHint) {
            setIncorrectValue(false);
          } else {
            setIncorrectValue(true);
          }
          props.setHintToggle(false);
        } else {
          if (props.passHint === undefined && props.x === 0) {
            setDraggedWord(answer[0]);
            const newGuess = props.guess;
            newGuess[props.x] = answer[0];
            const newAnsweredGuess = props.guess.toString();
            props.setGuessedAnswer(newAnsweredGuess.replaceAll(",", " "));
            props.setAttempts((a) => a + 1);
            props.setGuess(newGuess);
            props.setHintToggle(false);
          }
        }
      }
    } else {
    }
  }, [props.hint]);

  const noErrorChecking = (
    <div
      ref={goal}
      key={props.word.id}
      style={{
        borderBottom: isOver ? "solid 1px green" : "solid 1px #333",
        height: "20px",
      }}
      value={props.x}
    >
      {draggedWord}
    </div>
  );
  const errorCheckingChange = (
    <div
      ref={goal}
      key={props.word.id}
      style={{
        border: isOver
          ? "solid 3px green"
          : incorrectValue
          ? "solid 3px red"
          : "solid 3px #333",
        borderRadius: "20px",
        height: "120px",
        fontSize: "60px",
        textAlign: "center",
        color: incorrectValue ? "red" : "white",
      }}
      value={props.x}
    >
      {draggedWord}
    </div>
  );

  return (
    <>
      <Col key={props.word.id}>
        {!props.errorChecking && noErrorChecking}
        {props.errorChecking && errorCheckingChange}
      </Col>
    </>
  );
}
